import { render, staticRenderFns } from "./TestImageContextMenu.vue?vue&type=template&id=1c1d6ec8&scoped=true"
import script from "./TestImageContextMenu.vue?vue&type=script&lang=js"
export * from "./TestImageContextMenu.vue?vue&type=script&lang=js"
import style0 from "./TestImageContextMenu.vue?vue&type=style&index=0&id=1c1d6ec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1d6ec8",
  null
  
)

export default component.exports